import React, { createContext, useContext, useState, useEffect } from 'react';

// Define the column-based layout with heights
const LOCKER_COLUMNS = {
  A: [
    { type: 'Medium', height: 2 },
    { type: 'Medium', height: 2 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Large', height: 4 }
  ],
  B: [
    { type: 'Medium', height: 2 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Large', height: 4 }
  ],
  C: [
    { type: 'Medium', height: 2 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Keypad', height: 2 },
    { type: 'Small', height: 1 },
    { type: 'Medium', height: 2 },
    { type: 'Large', height: 4 }
  ],
  D: [
    { type: 'Medium', height: 2 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Medium', height: 2 },
    { type: 'Medium', height: 2 }
  ],
  E: [
    { type: 'Medium', height: 2 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Small', height: 1 },
    { type: 'Medium', height: 2 },
    { type: 'Medium', height: 2 }
  ]
};

const USERS = [
  { 
    email: 'eric@0gbaltics.com', 
    password: 'SB4321@', 
    name: 'Eric Brisset',
    department: 'Sales',
    rfid: 'RFID-ERIC'
  },
  { 
    email: 'didzis@0gbaltics.com', 
    password: 'SB4321@', 
    name: 'Didzis Tupureins',
    department: 'Business Development',
    rfid: 'RFID-DIDZIS'
  },
  { 
    email: 'alena@0gbaltics.com', 
    password: 'SB4321@', 
    name: 'Alena Ruplane',
    department: 'Administration',
    rfid: 'RFID-ALENA'
  }
];

const RECIPIENTS = [
  { value: 'Eric Brisset', label: 'Brisset Eric' },
  { value: 'Alena Ruplane', label: 'Ruplane Alena' },
  { value: 'Didzis Tupureins', label: 'Tupureins Didzis' },
  { value: '0g Baltics', label: '0g Baltics' }
];

// Generate initial lockers from column layout
const generateInitialLockers = () => {
  const lockers = [];
  let lockerId = 1;
  
  ['A', 'B', 'C', 'D', 'E'].forEach((col, colIndex) => {
    LOCKER_COLUMNS[col].forEach((cell, cellIndex) => {
      if (cell.type === 'Keypad') {
        lockers.push({
          id: 'KP-000',
          type: 'Keypad',
          size: 'Keypad',
          sizeCode: 'KP',
          column: col,
          columnIndex: colIndex,
          indexInColumn: cellIndex,
          height: cell.height,
          state: 'N/A',
          pin: null,
          user: null,
          recipient: null
        });
      } else {
        const id = `L-${String(lockerId).padStart(3, '0')}`;
        let sizeCode = '';
        
        switch(cell.type) {
          case 'Small': sizeCode = 'S'; break;
          case 'Medium': sizeCode = 'M'; break;
          case 'Large': sizeCode = 'L'; break;
        }
        
        lockers.push({
          id,
          type: cell.type,
          size: cell.type,
          sizeCode,
          column: col,
          columnIndex: colIndex,
          indexInColumn: cellIndex,
          height: cell.height,
          state: 'Free',
          pin: null,
          user: null,
          recipient: null
        });
        lockerId++;
      }
    });
  });
  
  return lockers;
};

const INITIAL_LOCKERS = generateInitialLockers();

// Preload some lockers with test data
const PRELOAD_LOCKERS = () => {
  const lockers = [...INITIAL_LOCKERS];
  
  // Occupy a few lockers for demo
  const occupyLocker = (id, pin, user, recipient) => {
    const index = lockers.findIndex(l => l.id === id);
    if (index !== -1) {
      lockers[index] = { ...lockers[index], state: 'Occupied', pin, user, recipient };
    }
  };
  
  occupyLocker('L-005', '7394', 'Alena Ruplane', 'Eric Brisset');
  occupyLocker('L-012', '2051', 'Eric Brisset', 'Didzis Tupureins');
  occupyLocker('L-025', '4821', 'Didzis Tupureins', 'Alena Ruplane');
  
  // Add some alerts
  const setAlert = (id) => {
    const index = lockers.findIndex(l => l.id === id);
    if (index !== -1) {
      lockers[index] = { ...lockers[index], state: 'Alert' };
    }
  };
  
  setAlert('L-030');
  setAlert('L-045');
  
  return lockers;
};

const INITIAL_LOGS = [
  { id: 1, timestamp: new Date('2025-01-15T08:30:00'), type: 'Deposit', locker: 'L-005', size: 'M', user: 'Alena Ruplane', recipient: 'Eric Brisset', pin: '7394' },
  { id: 2, timestamp: new Date('2025-01-15T09:15:00'), type: 'Deposit', locker: 'L-012', size: 'M', user: 'Eric Brisset', recipient: 'Didzis Tupureins', pin: '2051' },
  { id: 3, timestamp: new Date('2025-01-15T10:00:00'), type: 'Deposit', locker: 'L-025', size: 'S', user: 'Didzis Tupureins', recipient: 'Alena Ruplane', pin: '4821' },
  { id: 4, timestamp: new Date('2025-01-15T10:45:00'), type: 'Retrieve', locker: 'L-008', user: 'Eric Brisset', method: 'RFID' },
  { id: 5, timestamp: new Date('2025-01-15T11:30:00'), type: 'Retrieve', locker: 'L-015', user: 'Alena Ruplane', method: 'PIN' },
  { id: 6, timestamp: new Date('2025-01-15T12:00:00'), type: 'Retrieve', locker: 'L-020', user: 'Didzis Tupureins', method: 'RFID' },
  { id: 7, timestamp: new Date('2025-01-15T13:15:00'), type: 'Tamper', locker: 'L-030', alert: 'Door sensor triggered' },
  { id: 8, timestamp: new Date('2025-01-15T14:00:00'), type: 'Battery-low', locker: 'L-045', alert: 'Battery below 20%' },
  { id: 9, timestamp: new Date('2025-01-15T14:30:00'), type: 'Admin', locker: 'L-018', action: 'Force-open', user: 'Admin' },
  { id: 10, timestamp: new Date('2025-01-15T15:00:00'), type: 'Deposit', locker: 'L-033', size: 'M', user: 'Eric Brisset', recipient: '0g Baltics', pin: '5678' },
];

const AuthContext = createContext();

const LAYOUT_VERSION = '2.0'; // Increment this to force localStorage reset

export const AuthProvider = ({ children }) => {
  // Check version and reset if needed
  const savedVersion = localStorage.getItem('layoutVersion');
  if (savedVersion !== LAYOUT_VERSION) {
    localStorage.removeItem('lockers');
    localStorage.removeItem('logs');
    localStorage.setItem('layoutVersion', LAYOUT_VERSION);
    console.log('Layout updated - localStorage cleared');
  }

  const [currentUser, setCurrentUser] = useState(() => {
    const saved = localStorage.getItem('currentUser');
    return saved ? JSON.parse(saved) : null;
  });
  
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'en';
  });
  
  const [lockers, setLockers] = useState(() => {
    const saved = localStorage.getItem('lockers');
    return saved ? JSON.parse(saved) : PRELOAD_LOCKERS();
  });

  const [logs, setLogs] = useState(() => {
    const saved = localStorage.getItem('logs');
    if (saved) {
      const parsed = JSON.parse(saved);
      return parsed.map(log => ({ ...log, timestamp: new Date(log.timestamp) }));
    }
    return INITIAL_LOGS;
  });

  const [whiteLabel, setWhiteLabel] = useState(() => {
    const saved = localStorage.getItem('whiteLabel');
    return saved === 'true';
  });

  useEffect(() => {
    if (currentUser) {
      localStorage.setItem('currentUser', JSON.stringify(currentUser));
    } else {
      localStorage.removeItem('currentUser');
    }
  }, [currentUser]);
  
  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  useEffect(() => {
    localStorage.setItem('lockers', JSON.stringify(lockers));
  }, [lockers]);

  useEffect(() => {
    localStorage.setItem('logs', JSON.stringify(logs));
  }, [logs]);

  useEffect(() => {
    localStorage.setItem('whiteLabel', whiteLabel);
  }, [whiteLabel]);

  const login = (email) => {
    const user = USERS.find(u => u.email === email);
    if (user) {
      setCurrentUser(user);
      return true;
    }
    return false;
  };

  const logout = () => {
    setCurrentUser(null);
  };

  const generatePin = () => {
    return Math.floor(1000 + Math.random() * 9000).toString();
  };

  const depositParcel = (lockerId, size, pin, user, recipient) => {
    setLockers(prev => prev.map(l => 
      l.id === lockerId ? { ...l, state: 'Occupied', pin, user, recipient } : l
    ));
    
    const newLog = {
      id: logs.length + 1,
      timestamp: new Date(),
      type: 'Deposit',
      locker: lockerId,
      size,
      user,
      recipient,
      pin
    };
    setLogs(prev => [...prev, newLog]);
  };

  const retrieveParcel = (lockerId, method, user) => {
    const locker = lockers.find(l => l.id === lockerId);
    
    setLockers(prev => prev.map(l => 
      l.id === lockerId ? { ...l, state: 'Free', pin: null, user: null, recipient: null } : l
    ));
    
    const newLog = {
      id: logs.length + 1,
      timestamp: new Date(),
      type: 'Retrieve',
      locker: lockerId,
      method,
      user,
      from: locker?.user
    };
    setLogs(prev => [...prev, newLog]);
  };

  const simulateEvent = (type, lockerId, data = {}) => {
    if (type === 'Tamper' || type === 'Battery-low') {
      setLockers(prev => prev.map(l => 
        l.id === lockerId ? { ...l, state: 'Alert' } : l
      ));
    }

    const newLog = {
      id: logs.length + 1,
      timestamp: new Date(),
      type,
      locker: lockerId,
      ...data
    };
    setLogs(prev => [...prev, newLog]);
  };

  const resetDemo = () => {
    setLockers(PRELOAD_LOCKERS());
    setLogs(INITIAL_LOGS);
    localStorage.removeItem('lockers');
    localStorage.removeItem('logs');
  };

  const exportLogs = () => {
    const headers = ['ID', 'Timestamp', 'Type', 'Locker', 'User', 'Recipient', 'Details'];
    const rows = logs.map(log => [
      log.id,
      log.timestamp.toISOString(),
      log.type,
      log.locker,
      log.user || 'N/A',
      log.recipient || 'N/A',
      log.pin ? `PIN: ${log.pin}` : log.alert || log.action || log.method || 'N/A'
    ]);

    const csv = [headers, ...rows].map(row => row.join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `locker-logs-${new Date().toISOString().split('T')[0]}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const value = {
    // Auth
    currentUser,
    login,
    logout,
    users: USERS,
    recipients: RECIPIENTS,
    
    // Language
    language,
    setLanguage,
    
    // Lockers
    lockers,
    logs,
    lockerColumns: LOCKER_COLUMNS,
    whiteLabel,
    setWhiteLabel,
    generatePin,
    depositParcel,
    retrieveParcel,
    simulateEvent,
    resetDemo,
    exportLogs
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
